<template>
    <div class="page-status">
        <div class="statusHeight" :style="{height:statusHeight + 'rem'}"></div>
        <div class="title-bar">
            <div class="title-name">{{$store.webTitle}}</div>
            <div  v-if="leftEle"
                  class="left-ele alifont" :class="leftEle.iconName"
                  :style="{color:leftEle.color?leftEle.color: '#333',fontSize:leftEle.fontSize?leftEle.fontSize:'.24rem'}"
                  @click="leftEleMethod"></div>
            <div v-if="rightEle"
                 class="right-ele alifont" :class="rightEle.iconName"
                 :style="{color:rightEle.color?rightEle.color: '#333',fontSize:rightEle.fontSize?rightEle.fontSize:'.24rem'}"
                 @click="rightEleMethod"></div>
            <div v-if="rightText"
                 class="right-ele"
                 :style="{color:rightText.color?rightText.color: '#333',fontSize:rightText.fontSize?rightText.fontSize:'.24rem'}"
                 @click="rightTextMethod">{{rightText.text}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "baseTitleBar",
        props:{
            leftEle:{
                type:Object,
                default:  ()=>{
                    return null
                }
            },
            rightEle:{
                type:Object,
                default:  ()=>{
                    return null
                }
            },
            rightText:{
                type:Object,
                default:  ()=>{
                    return null
                }
            }
        },
        data(){
            return{
                statusHeight:'0'
            }
        },
        methods:{
            leftEleMethod(){
                if(this.leftEle.method){
                    this.leftEle.method()
                }
            },
            rightEleMethod(){
                if(this.rightEle.method){
                    this.rightEle.method()
                }
            },
            rightTextMethod(){
                if(this.rightText.method){
                    this.rightText.method()
                }
            },
            initAppStatus(){
                try {
                    window.native.getApp();
                    this.appStatusHeight = JSON.parse(window.native.getStatusHeight('light')).status;
                    this.appScreenWidth = JSON.parse(window.native.getStatusHeight('light')).width;
                    this.statusHeight = this.appStatusHeight / this.appScreenWidth * 750 /100;
                }catch (e) {
                    // this.statusHeight = '.2'
                }
            }
        },
        mounted(){
            this.initAppStatus();
        },
    }
</script>

<style scoped lang="scss">
    .title-bar{
        width: 100%;
        height: .9rem;
        position: relative;
        background: #fff;
    }
    .title-name{
        margin: auto;
        line-height: .9rem;
        font-size: .32rem;
        max-width: 4.5rem;
        color: #333;
        text-align: center;
    }
    .left-ele{
        height: .9rem;
        line-height: .9rem;
        text-align: center;
        position: absolute;
        left: .24rem;
        top: 0;
    }
    .right-ele{
        height: .9rem;
        line-height: .9rem;
        text-align: center;
        position: absolute;
        right: .24rem;
        top: 0;
    }
</style>



// WEBPACK FOOTER //
// baseTitleBar.vue?e4599976